import type { ComponentType, SVGProps } from "react";

export interface IconProps extends SVGProps<SVGSVGElement> {
  size?: number | "auto" | (string & {});
  // Explicitly re-declared so TypeScript resolves these even when @types/react
  // is not reachable from packages/icons in pnpm's non-hoisted node_modules layout.
  className?: string;
  color?: string;
  fill?: string;
  stroke?: string;
  style?: Record<string, string | number>;
  "aria-label"?: string;
  "aria-hidden"?: boolean | "true" | "false";
  role?: string;
}

export interface PrivateIconProps extends IconProps {
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
}

export const Icon = ({ Icon, size = 24, ...props }: PrivateIconProps) => {
  return (
    <Icon
      width={size === "auto" ? undefined : size}
      height={size === "auto" ? undefined : size}
      {...props}
    />
  );
};
